(() => {
  const script = document.currentScript;
  const allProductsUrl = script?.dataset.fizoAllProductsUrl || '/collections/all';
  const selector = '[data-fizo-plp-category],[data-fizo-plp-designer]';

  const destinationFor = (trigger) => {
    const designerId = trigger.dataset.fizoPlpDesignerId?.trim();
    const category = trigger.dataset.fizoPlpCategory?.trim();
    const value = designerId || category;
    if (!value) return '';
    const url = new URL(allProductsUrl, window.location.origin);
    url.search = '';
    url.hash = '';
    url.searchParams.set('view', designerId ? 'designer' : 'category');
    url.searchParams.set(designerId ? 'filter.p.m.custom.designer_master_profile' : 'filter.p.product_type', value);
    return `${url.pathname}${url.search}`;
  };

  const activate = (event, trigger) => {
    const destination = destinationFor(trigger);
    if (!destination) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.assign(destination);
  };

  document.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const trigger = event.target.closest(selector);
    if (trigger) activate(event, trigger);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const trigger = event.target.closest(selector);
    if (trigger) activate(event, trigger);
  });
})();
